import { Grid, Box, useTheme } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DefaultLogo from '@shared/assets/air/iconBlack.png';
import { findScale } from '@shared/helpers/flights/flights';

import ItineraryTitle from '@FlightsComponents/ItineraryTitle';
import ItineraryText from '@FlightsComponents/ItineraryText';

const FlightItineraryHeader = ({
  leg,
  cluster,
  option,
  withEquipment = false,
  firstFlight = {},
}) => {
  const theme = useTheme();

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ width: '100%' }}
    >
      {/* Title + Equipment */}
      <Grid
        item
        xs="auto"
        id="grid-title-equipment"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          alignSelf: 'center',
        }}
      >
        {/* Título con escala */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ItineraryTitle>{leg.title}</ItineraryTitle>

          <ArrowForwardIcon sx={{ color: theme.primary }} />

          <ItineraryTitle>{findScale(option)}</ItineraryTitle>
        </Box>

        {/* Equipo y número de vuelo */}
        {withEquipment && firstFlight.equipment_description && (
          <ItineraryText textAlign="left" lineHeight={1}>
            {`Equipo: ${firstFlight.equipment_description} - Nº Vuelo: ${firstFlight.airline.code} ${firstFlight.flight_number}`}
          </ItineraryText>
        )}
      </Grid>

      {/* Logo + Airline Name */}
      <Grid
        item
        xs="auto"
        sx={{
          display: 'flex',
          alignItems: withEquipment ? 'flex-start' : 'center',
          gap: 1,
        }}
      >
        <Box
          component="img"
          src={cluster?.carrier?.logo || DefaultLogo}
          alt="aerolinea"
          sx={{
            width: { xs: 22, md: 30 },
            height: { xs: 22, md: 30 },
          }}
        />
        <ItineraryTitle
          sx={{
            alignSelf: 'center',
            fontWeight: 400,
            display: { xs: 'none', sm: 'none', md: 'block' },
          }}
        >
          {cluster?.carrier?.description || cluster?.carrier?.code}
        </ItineraryTitle>
      </Grid>
    </Grid>
  );
};

export default FlightItineraryHeader;
